export default __webpack_public_path__ + "static/media/facebook-dark-old.45ba54a3.svg";